import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import Tab from "@mui/material/Tab";
import { useContext, useState } from "react";
import { ListUsers } from "../resources/User/ListUsers";
import { AuthContext } from "../providers/AuthContextProvider";
import { useTenantStore } from "../providers/TenantContextProvider";
import ElectionHeader from "../components/ElectionHeader";
import { useTranslation } from "react-i18next";
import { ListRoles } from "../resources/Roles/ListRoles";
import { IPermissions } from "../types/keycloak";
import { SidebarScreenStyles } from "@/components/styles/SidebarScreenStyles";
import { ResourceListStyles } from "@/components/styles/ResourceListStyles";
import { Typography } from "@mui/material";
export var UserAndRoles = function () {
    var authContext = useContext(AuthContext);
    var tenantId = useTenantStore()[0];
    var _a = useState(0), value = _a[0], setValue = _a[1];
    var t = useTranslation().t;
    var showUsers = authContext.isAuthorized(true, tenantId, IPermissions.USER_READ);
    var showRoles = authContext.isAuthorized(true, tenantId, IPermissions.ROLE_READ);
    var handleChange = function (event, newValue) {
        setValue(newValue);
    };
    var showUsersMenu = authContext.isAuthorized(true, tenantId, IPermissions.USERS_MENU);
    if ((!showUsers && !showRoles) || !showUsersMenu) {
        return (_jsx(ResourceListStyles.EmptyBox, { children: _jsx(Typography, { variant: "h4", paragraph: true, children: t("usersAndRolesScreen.noPermissions") }) }));
    }
    return (_jsxs(_Fragment, { children: [_jsx(ElectionHeader, { title: "usersAndRolesScreen.common.title", subtitle: "usersAndRolesScreen.common.subtitle" }), _jsxs(SidebarScreenStyles.Tabs, { value: value, onChange: handleChange, "aria-label": "Users and Roles tabs", children: [showUsers ? _jsx(Tab, { label: String(t("usersAndRolesScreen.users.title")) }) : null, showRoles ? _jsx(Tab, { label: String(t("usersAndRolesScreen.roles.title")) }) : null] }), _jsx(SidebarScreenStyles.CustomTabPanel, { value: value, index: 0, children: _jsx(ListUsers, {}) }), _jsx(SidebarScreenStyles.CustomTabPanel, { value: value, index: 1, children: _jsx(ListRoles, {}) })] }));
};
